export default {"src":"/_next/static/media/favicon.e453aa27.svg","height":32,"width":32};